import { render, staticRenderFns } from "./EditPostPage.vue?vue&type=template&id=42c3562e&"
import script from "./EditPostPage.vue?vue&type=script&lang=js&"
export * from "./EditPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports